import React, { useState } from "react";
import { HiChatAlt2, HiX } from "react-icons/hi";

const FloatingChat = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
            {/* Floating Chat Box Popup */}
            <div
                className={`mb-4 w-72 bg-white rounded-2xl shadow-2xl border border-zinc-200 overflow-hidden transition-all duration-300 transform origin-bottom-right ${isOpen ? "scale-100 opacity-100 translate-y-0" : "scale-50 opacity-0 translate-y-10 pointer-events-none"
                    }`}
            >
                <div className="bg-black text-white p-4 flex justify-between items-center">
                    <h3 className="font-bold tracking-wide">Direct Chat</h3>
                    <button onClick={() => setIsOpen(false)} className="text-zinc-400 hover:text-white transition-colors">
                        <HiX className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-5 flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center mb-3">
                        <span className="text-2xl" role="img" aria-label="wave">👋</span>
                    </div>
                    <p className="text-zinc-600 text-sm mb-4 leading-relaxed">
                        Have a project in mind I reply to direct messages via Gmail jenlabastidavisuals@gmail.com
                    </p>
                    <a
                        href="mailto:jenemae@gmail.com"
                        className="w-full bg-black text-white py-3 rounded-lg font-bold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all outline-none"
                        onClick={() => setIsOpen(false)}
                    >
                        Open in Gmail
                    </a>
                </div>
            </div>

            {/* Primary Toggle Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:scale-105 active:scale-95 transition-all outline-none group"
                aria-label="Open Direct Chat"
            >
                <div className="relative">
                    {isOpen ? (
                        <HiX className="w-8 h-8 group-hover:rotate-90 transition-transform duration-300" />
                    ) : (
                        <HiChatAlt2 className="w-8 h-8 group-hover:-rotate-12 transition-transform duration-300" />
                    )}

                    {/* Status Indicator Pulse */}
                    {!isOpen && (
                        <span className="absolute -top-1 -right-1 flex h-4 w-4">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-4 w-4 bg-green-500 border-2 border-black"></span>
                        </span>
                    )}
                </div>
            </button>
        </div>
    );
};

export default FloatingChat;
